import { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './anrokLogo.svg'
import { NoConfiguration } from 'modules/Integrations/integrationsConfig/common/NoConfiguration'
import { AnrokIntegrationDetail } from './AnrokIntegrationDetail'
import { AnrokConfigurationManagement } from './AnrokConfigurationManagment/AnrokConfigurationManagement'
import { anrokConfigurationLoader } from './anrok.loader'
import { anrokConfigurationMutator } from './anrok.mutator'

export const anrokIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/anrok',
  title: 'Anrok',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false,
    disableSubmitUntilValid: true
  },
  description: 'Automatically calculate sales tax for invoices.',
  components: {
    detail: AnrokIntegrationDetail,
    management: AnrokConfigurationManagement
  },
  communication: {
    configuration: {
      loader: anrokConfigurationLoader,
      mutator: anrokConfigurationMutator
    }
  }
}
export type AnrokIntegrationConfig = {
  apiKey?: string
  obfuscatedApiKey: string
}
